/* eslint-disable react/jsx-no-constructed-context-values */
import { useMsal } from '@azure/msal-react';
import React from 'react';

export type Permission = {
  standardAccess: boolean,
};

const PermissionContext = React.createContext<Permission>({
  standardAccess: false,
});

export const usePermission = () => React.useContext<Permission>(PermissionContext);

export const PermissionProvider: React.FunctionComponent<React.PropsWithChildren> = ({
  children,
}) => {
  const { accounts } = useMsal();
  const account = accounts.filter((accountInfo) => accountInfo.tenantId === process.env.REACT_APP_TENANT_ID)[0];
  const roles = account && account.idTokenClaims && account.idTokenClaims.roles;
  let standardAccess = false;

  if (Array.isArray(roles) && roles?.indexOf('User.StandardAccess') > -1) {
    standardAccess = true;
  }

  return (
    <PermissionContext.Provider value={{
      standardAccess,
    }}
    >
      {children}
    </PermissionContext.Provider>
  );
};
